import { createFileRoute } from '@tanstack/react-router'
import { NestedReportPending } from './-components/shared/nested-report-pending'
import { useTeam } from '@/hooks/use-team'
import { Evaluation } from './-components/shared/evaluation'

export const Route = createFileRoute('/_app/teams/$teamId/evaluation')({
  component: RouteComponent,
  pendingComponent: NestedReportPending,
})

function RouteComponent() {
  const { teamId } = Route.useParams()
  const { team } = useTeam()

  // Convert member IDs from number to string to match Member interface
  const members = (team?.members ?? []).map((member) => ({
    ...member,
    id: member.id.toString(),
    evaluations: member.evaluations.map((e) => ({
      ...e,
      memberId: e.memberId,
    })),
  }))

  return <Evaluation teamId={teamId} members={members} data={team?.evaluationMatrix} />
}
